export default {
  EN_APAC: 'EN-APAC',
  EN_AMERICAS: 'EN-AMERICAS',
  EN_UK: 'en-GB',
  EN_EMEA: 'en-EU',
  en: 'en',
  de: 'de-DE',
  DE_CH: 'de-CH',
  FR: 'fr-FR',
  NO: 'nb-NO',
  // DGX-346: Swedish and Danish markets are English-only. The legacy 'sv-SE'
  // (still used by Finland) and 'da-DK' codes remain handled where needed.
  SE: 'en-SE',
  DK: 'en-DK',
  AT: 'de-AT',
};
